import styled from '../../styled';
import { COLORS } from '../../themes/color';

/**
 * Monospace micro-label used above section headlines,
 * e.g. `AGENT · MCP · CAMPAIGNS`.
 */
export const Kicker = styled('div')<{ onDark?: boolean }>`
  font-family: 'SF Mono', 'Roboto Mono', 'Fira Mono', monospace;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: ${(p) => (p.onDark ? COLORS.PRIMARY_LIGHT : COLORS.PRIMARY)};
  margin-bottom: 16px;
`;
